import { css } from '@emotion/react'
import { Color, FontWeight, Spacing, Typography } from '@opallabs/gem'

type Selected = {
  selected?: boolean
}

export const list = css({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  padding: 0,
})

export const item = ({ selected }: Selected) =>
  css({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    cursor: 'pointer',
    listStyle: 'none',
    border: '1px solid transparent',
    borderRadius: '8px',
    padding: `${Spacing.XS * 3}px ${Spacing.M}px`,
    position: 'relative',
    height: 42,
    gap: Spacing.S,
    marginBottom: Spacing.M,
    borderColor: selected ? Color.light.Surface.A200 : 'transparent',
    background: selected ? Color.light.Surface.A000 : 'transparent',
    '.lapidary-history-title': {
      color: selected ? Color.light.Surface.A200 : Color.light.Text.Default,
    },
    '.lapidary-history-subtitle': {
      color: selected ? Color.light.Text.Default : '#7a7a7a',
    },
  })

export const textContainer = css({
  display: 'flex',
  flexDirection: 'column',
  flex: '1 1 auto',
})

export const title = css({
  ...Typography.T500,
  fontWeight: FontWeight.Semibold,
  lineHeight: '20px',
})

export const subtitle = css({
  ...Typography.T300,
  fontWeight: 400,
})

export const currentPill = css({
  paddingInline: Spacing.XS * 1.5,
  marginRight: Spacing.XS,
})
